import React from 'react';
import { motion } from 'framer-motion';
import { useApp, MOCK_PRODUCTS } from '../context/AppContext';
import { Header } from '../components/ui/Header';
import { ProductCard } from '../components/ui/ProductCard';
export function RecommendedScreen() {
  // Use all products for the recommended view in this prototype
  const recommended = [...MOCK_PRODUCTS].sort(() => 0.5 - Math.random());
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50" data-id="element-1258">
      <Header title="Recommended For You" data-id="element-1259" />

      <div className="p-4 grid grid-cols-2 gap-4" data-id="element-1260">
        {recommended.map(product => <ProductCard key={product.id} product={product} data-id="element-1261" />)}
        {/* Duplicate for visual fullness in prototype */}
        {recommended.map(product => <ProductCard key={`${product.id}-dup`} product={{
        ...product,
        id: `${product.id}-dup`
      }} data-id="element-1262" />)}
      </div>
    </motion.div>;
}